import { at } from 'lodash';
export default (officer = {}) =>
  at(officer, ['rank.name', 'firstName', 'lastName'])
    .filter(value => value)
    .join(' ');
